export enum AssessmentValue {
  ExceptionallyGood = 4,
  Successful = 3,
  AtTheEdge = 2,
  NotThatGood = 1,
  NotYetRated = 0,
}

export enum ExtendedAssessmentValue {
  ExceptionallyGood = 5,
  AboveExpectations = 4,
  MeetExpectations = 3,
  AtTheEdge = 2,
  NotThatGood = 1,
}

export enum CoreValueOption {
  BeEntepreneurial = 1,
  BeFocused = 2,
  BeInnovative = 3,
  BeFair = 4,
  NotYetRated = 0,
}



// WEBPACK FOOTER //
// ./src/app/front-face/shared/review/rating-value.ts